import ChangeStatus from './ChangeStatus';
import ExportExcel  from './ExportExcel' ;
import DisApprove   from './DisApprove'  ;
import Send2Bank    from './Send2Bank'   ;
import Approve      from './Approve'     ;
import Request      from './Request'     ;
import Search       from './Search'      ;
import Filter       from './Filter'      ;

type withdrawalComponent = {
  ChangeStatus : typeof ChangeStatus;
  ExportExcel  : typeof ExportExcel ;
  DisApprove   : typeof DisApprove  ;
  Send2Bank    : typeof Send2Bank   ;
  Approve      : typeof Approve     ;
  Request      : typeof Request     ;
  Search       : typeof Search      ;
  Filter       : typeof Filter      ;
};

const WithdrawalComponent: withdrawalComponent = {
  ChangeStatus,
  ExportExcel ,
  DisApprove  ,
  Send2Bank   ,
  Approve     ,
  Request     ,
  Search      ,
  Filter      ,
};

export default WithdrawalComponent;
